import { useMemo } from 'react';
import type { FC } from 'react';
import './CashFlowDashboard.css';
import DashboardHeaderBalanceSheet from './DashboardHeaderBalanceSheet';

interface BalanceSheetData {
    totalAssets?: {
        value: number;
        formattedValue: string;
        label: string;
    };
    totalLiabilities?: {
        value: number;
        formattedValue: string;
        label: string;
    };
    totalEquity?: {
        value: number;
        formattedValue: string;
        label: string;
    };
    [key: string]: any;
}

interface BalanceSheetDashboardProps {
    balanceSheetData: BalanceSheetData;
    showChart?: boolean;
}

const BalanceSheetDashboard: FC<BalanceSheetDashboardProps> = ({ 
    balanceSheetData, 
    showChart = false 
}) => {
    const keyMetrics = useMemo(() => {
        if (!balanceSheetData) return null;

        return {
            totalAssets: balanceSheetData.totalAssets,
            totalLiabilities: balanceSheetData.totalLiabilities,
            totalEquity: balanceSheetData.totalEquity
        };
    }, [balanceSheetData]);

    return (
        <div className="cash-flow-dashboard" style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 10, minHeight: 0 }}>
            <DashboardHeaderBalanceSheet keyMetrics={keyMetrics} />
            {/* Chart section can be added here if needed in the future */}
            {showChart && (
                <div className="mt-4 p-4 bg-slate-800 rounded-lg">
                    <p className="text-slate-400">Chart visualization can be added here</p>
                </div>
            )}
        </div>
    );
};

export default BalanceSheetDashboard;
